const SAMPLE_QUOTES = [
  { who: "Hostile VC", text: "Your TAM math is wrong by an order of magnitude." },
  { who: "Skeptical Customer", text: "I'd never pay for this — I solve it with a Notion template." },
  { who: "Competitor", text: "We can copy this in a two-week sprint. Why does it exist?" },
  { who: "Domain Expert", text: "You've ignored the only regulation that actually matters here." },
  { who: "Devil's Advocate", text: "If GPT-X commoditizes intent, this entire wedge evaporates." },
];

export default function SampleQuotes() {
  return (
    <section className="border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <div className="tag mb-6">02 · SAMPLE OUTPUT</div>
            <h2 className="font-display font-black text-3xl md:text-5xl tracking-tighter leading-tight">
              The panel doesn&apos;t <span className="text-[#FF3333]">care</span> about your feelings.
            </h2>
            <p className="mt-6 text-white/60">
              A few real lines from past sessions. Names changed. Pain preserved.
            </p>
          </div>

          <div className="md:col-span-8 scanlines border border-white/10 bg-[#0a0a0a] p-6 md:p-10 font-mono text-sm">
            {SAMPLE_QUOTES.map((q) => (
              <div key={q.who} className="py-3 border-b border-white/10 last:border-0">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#E5FE40]">
                  &gt; {q.who}
                </div>
                <div className="mt-2 text-white/85">{q.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
